import React, {PropsWithChildren} from "react"
import Icon from "../Icon/Icon"
import classNames from "classnames"

interface ConfirmationModalProps {
	classname?: string
	title: string
	okButtonText?: string
	okButtonClassname?: string
	cancelButtonText?: string
	cancelButtonClassname?: string
	onSubmit: () => void
	close: () => void
}

export function ConfirmationModal({
	classname,
	title,
	okButtonText = "OK",
	okButtonClassname = "button is-success mr-2",
	cancelButtonText = "Cancel",
	cancelButtonClassname = "button has-background-grey-lighter",
	onSubmit,
	close,
	children,
}: PropsWithChildren<ConfirmationModalProps>) {
	return (
		<div className={classNames("modal", "is-active", "confirmation-modal", classname)}>
			<div className="modal-background" />
			<form
				onSubmit={(e) => {
					e.preventDefault()
					onSubmit()
					close()
				}}
			>
				<div className="modal-card">
					<header className="modal-card-head">
						<label className="delete" onClick={() => close()}>
							<Icon icon="interface-delete-interface-essential" size={16} />
						</label>
					</header>
					<section className="modal-card-body">
						<h3 className="modal-card-title confirmation-modal-card-title">{title}</h3>
						<fieldset>{children}</fieldset>
					</section>
					<footer className="modal-card-foot">
						<input type="button" className={cancelButtonClassname} value={cancelButtonText} onClick={close} />
						<input type="submit" className={okButtonClassname} value={okButtonText} />
					</footer>
				</div>
			</form>
		</div>
	)
}
